import React from 'react';
import { Globe } from 'lucide-react';
import { Language, languageNames, Translations } from '../../i18n/translations';

interface LanguageSettingsProps {
  language: Language;
  onLanguageChange: (lang: Language) => void;
  t: Translations;
}

export const LanguageSettings: React.FC<LanguageSettingsProps> = ({
  language,
  onLanguageChange,
  t,
}) => {
  const languages: Language[] = ['en', 'pl'];

  return (
    <div className="bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 p-4 mb-4">
      <h3 className="font-bold mb-3 flex items-center gap-2 text-gray-900 dark:text-white">
        <Globe className="w-4 h-4" />
        {t.language}
      </h3>
      <p className="text-sm text-gray-600 dark:text-gray-400 mb-3">
        {t.languageDesc}
      </p>
      <div className="flex gap-2">
        {languages.map((lang) => (
          <button
            key={lang}
            onClick={() => onLanguageChange(lang)}
            className={`px-4 py-2 text-sm font-semibold border-2 ${
              language === lang
                ? 'bg-black text-white border-black dark:bg-white dark:text-black dark:border-white'
                : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-100 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-600 dark:hover:bg-gray-600'
            }`}
          >
            {languageNames[lang]}
          </button>
        ))}
      </div>
    </div>
  );
};
